export async function streamPost(url, body, token, onToken) {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
    credentials: "include",
  });
  if (!res.ok) {
    let detail = "Request failed";
    try {
      detail = (await res.json()).detail || detail;
    } catch {}
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  let doneData = null;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      let data;
      try {
        data = JSON.parse(p.slice(6));
      } catch {
        continue;
      }
      if (data.t) {
        full += data.t;
        onToken(data.t);
      }
      if (data.done) doneData = data;
      if (data.error) throw new Error(data.error);
    }
  }
  return { text: full, done: doneData };
}
